import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { css } from 'lib/paypalphrodite'
import TextArea from 'react-textarea-autosize'
import { Icon } from '@paypalcorp/pp-react'
import $ from 'jquery'
import styles from './note-redux.styles'
import content from 'pp-react-l10n'
import {
  trackAmountPageClick,
  trackClickUnifiedSend,
} from '../utils/unified-send-analytics'
import {
  ActionTypes as types,
  DONATION_NOTE_MAX_CHAR_LIMIT,
} from '../constants'
import { tracking } from '../../lib/analytics/mParticle'
import Events from '../../lib/analytics/eventTags'
import enRTRStrings from '../../../../config/enRTRStrings'
import _ from 'lodash'
import { connect } from 'transfer/utils/p2p-connect'

let i18n = content('transfer/page/preview')

class Note extends React.Component {
  static propTypes = {
    handleChangeNote: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    isCharity: PropTypes.bool,
    note: PropTypes.string,
    label: PropTypes.string,
    recipient: PropTypes.string,
    flowType: PropTypes.string,
    isReview: PropTypes.bool,
    hasFetchedFundingOptions: PropTypes.bool,
    showENSubTextRTR: PropTypes.bool,
    isDonate: PropTypes.bool,
    dispatch: PropTypes.func,
    isMissingMandatoryNote: PropTypes.bool,
  }

  static defaultProps = {
    note: '',
    disabled: false,
    hasFetchedFundingOptions: false,
  }

  state = {
    noteHasTracked: false,
    textAreaIsFocused: false,
    hideLabel: false, // used for transition and opacity
    removeLabel: false, // used for actually "removing" the label from the flow (so the TextArea can be clicked)
  }

  /**
   * This handles the case where a note exists before the component mounts. Let's hide the label.
   */
  componentWillMount() {
    if (this.props.note) {
      this.setState({
        hideLabel: true,
        removeLabel: true,
      })
    }
  }

  componentDidMount() {
    $(this.label).on('transitionend', this.handleLabelTransitionEnd)
  }

  componentWillReceiveProps(nextProps) {
    const { textAreaIsFocused } = this.state
    const noteExists = !!nextProps.note
    const existenceIsNew = !this.props.note && noteExists
    const absenceIsNew = this.props.note && !noteExists

    // This handles the case where a note is introduced after the component mounts, but from
    // another note field (e.g. from the theme card)
    if (noteExists && existenceIsNew) {
      this.setState({
        hideLabel: true,
        removeLabel: true,
      })
    }

    // This handles the case where a note is deleted after the component mounts, but from
    // another note field (e.g. from the theme card)
    if (!textAreaIsFocused && !noteExists && absenceIsNew) {
      this.setState({
        hideLabel: false,
        removeLabel: false,
      })
    }
  }

  handleLabelTransitionEnd = () => {
    const justTransitionedOut = this.state.hideLabel
    if (justTransitionedOut) {
      this.setState({
        removeLabel: true,
      })
    }
  }
  showNoteFieldError = () =>
    this.props.dispatch({ type: types.EXTERNAL.SHOW_NOTE_MAX_CHAR_LIMIT_ERROR })

  hideNoteFieldError = () =>
    this.props.dispatch({ type: types.EXTERNAL.HIDE_NOTE_MAX_CHAR_LIMIT_ERROR })

  hideMandatoryNoteFieldError = () => {
    this.props.dispatch({
      type: types.NOTE.REQUIRED_FIELD_ERROR,
      data: { missing: false },
    })
  }

  handleTextAreaChange = ({ target: { value: note } }) => {
    if (this.props.isDonate && note.length >= DONATION_NOTE_MAX_CHAR_LIMIT) {
      this.showNoteFieldError()
      return false
    }

    // hide mandatory message alert if isMissingMandatoryNotes flag is true and a valid note is entered
    if (this.props.isMissingMandatoryNote && note.trim().length > 0) {
      this.hideMandatoryNoteFieldError()
    }

    this.hideNoteFieldError()
    this.props.handleChangeNote(note)
  }

  handleTextAreaFocus = _.debounce(() => {
    const {
      isReview,
      flowType,
      recipient,
      hasFetchedFundingOptions,
    } = this.props
    if (!this.state.noteHasText) {
      if (hasFetchedFundingOptions) {
        tracking(Events.p2p_review_note_typing_started({}))
      } else {
        tracking(Events.p2p_amount_note_typing_started({}))
      }
      this.setState({ noteHasTracked: true })
    }
    if (isReview) {
      trackClickUnifiedSend(
        flowType === 'buy' ? 'onGSclickNoteField' : 'onFFclickNoteField'
      )
    } else {
      trackAmountPageClick(flowType, recipient, 'note')
    }

    this.setState({
      textAreaIsFocused: true,
      hideLabel: true, // then after the transitionend we removeFlow: true
    })
  }, 300)

  handleTextAreaBlur = () => {
    this.setState({
      textAreaIsFocused: false,
      hideLabel: !!this.props.note,
      removeLabel: !!this.props.note,
    })
  }

  getLabelKey = () => {
    return this.props.label ? this.props.label : i18n('note')
  }

  render() {
    const { hideLabel, removeLabel } = this.state
    const { note, disabled, showENSubTextRTR } = this.props

    const labelClassNames = {
      [css(styles.label)]: true,
      [css(styles.transitionOut)]: hideLabel,
      [css(styles.noSize)]: removeLabel,
    }

    const wrapperClassNames = {
      [css(styles.noteWrapper)]: true,
      [css(styles.disabledAndEmptyNoteWrapper)]: disabled && !note,
      [css(styles.donateNoteWrapper)]: this.props.isDonate,
    }

    const textAreaClassNames = {
      [css(styles.textArea)]: true,
      [css(styles.displayHidden)]: disabled && !note,
    }

    const labelContentsWrapperClassNames = {
      [css(styles.labelContentsWrapper)]: true,
      [css(styles.rtrLabelContentsWrapper)]:
        showENSubTextRTR && !this.props.label,
    }

    const editIconClassNames = {
      [css(styles.editIcon)]: true,
      [css(styles.rtrEditIcon)]: showENSubTextRTR && !this.props.label,
    }

    const noteLabelTextClassNames = {
      'ppvx_text--hero': true,
      [css(styles.labelTextBig)]: true,
      [css(styles.rtrNoteLabelText)]: showENSubTextRTR && !this.props.label,
    }

    return (
      <div className={classNames(wrapperClassNames)}>
        <label
          htmlFor="noteField"
          ref={c => (this.label = c)}
          className={classNames(labelClassNames)}
        >
          {!disabled && (
            <div className={classNames(labelContentsWrapperClassNames)}>
              <Icon
                name={this.props.isDonate ? 'add' : 'edit'}
                size="xs"
                className={classNames(editIconClassNames)}
              />
              <p className={classNames(noteLabelTextClassNames)}>
                {showENSubTextRTR === true && !this.props.label ? (
                  <>
                    <div>{this.getLabelKey()}</div>
                    <div className={css(styles.rtrNoteENSubText)}>
                      {enRTRStrings.note}
                    </div>
                  </>
                ) : (
                  this.getLabelKey()
                )}
              </p>
            </div>
          )}
        </label>
        <TextArea
          value={note}
          id="noteField"
          data-nemo="note-field"
          maxLength="1000"
          type="text"
          disabled={disabled}
          className={classNames(textAreaClassNames)}
          onChange={this.handleTextAreaChange}
          onFocus={this.handleTextAreaFocus}
          onBlur={this.handleTextAreaBlur}
        />
      </div>
    )
  }
}

/**
 * The Guest Flow Revamp Feature also shows Member preview page now.
 * And guestRevampInfoCollection.js is a React functional component, which cannot use connect().
 * Hence, when we invoke note-redux.js from guestRevampInfoCollection.js, this(note-redux.js) class component needs to be connected again to the redux store again.
 * if we dont do this, the this.props.dispatch goes 'undefined'.
 *
 * Using empty connect() will pass the required default dispatch props.
 */
export default connect(({ note }) => ({
  isMissingMandatoryNote: note.isMissingMandatoryNote,
}))(Note)
